var isBrowser = typeof window !== 'undefined';
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;
var PureRenderMixin = require('react-addons-pure-render-mixin');
var LinkWrapper = require('../../../components/linkWrapper.jsx')(Link);

var CondtionNavListItem = createReactClass({
    mixins: [PureRenderMixin],

	handleOnMouseEnter: function() {
        if(Foundation.MediaQuery.atLeast('large')){
            this.props.setActiveCondition && this.props.setActiveCondition(this.props.condition);
        }
	},

	render: function(){
        var activeCondition = this.props.activeCondition,
            condition = this.props.condition;

		return (
            <li className={'special-menu-list-item' + (activeCondition.name === condition.name ? ' active' : '')} onMouseEnter={this.handleOnMouseEnter}>
                <LinkWrapper
                    to={ '/conditions/' + condition.friendlyUrl }
                    handler={this.props.clickTracking}
                    className="inner">

                    <div className="tit">
                      <h3>{ condition.name }</h3>
                    </div>
                    <div className="des">
                        <p className="des-inner">{ condition.displayName || condition.title }</p>
                    </div>
                </LinkWrapper>
            </li>
	    )
	}
});

module.exports = CondtionNavListItem;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/layout/condtionNavListItem.jsx